import { createSelector } from 'reselect';
import { initialState } from './bank.reducers';

const selectBank = (state: any) => state.bankReducer || initialState;

const makeSelectBank = () =>
  createSelector(
    selectBank,
    bankState => bankState,
  );

const makeSelectPaymentsResume = () =>
  createSelector(
    selectBank,
    bankState => bankState.paymentsResume,
  );

const makeSelectPendingPayments = () =>
  createSelector(
    selectBank,
    bankState => bankState.pendingPayments,
  );

const makeSelectSocialProjects = () =>
  createSelector(
    selectBank,
    bankState => bankState.socialProjects,
  );

const makeSelectTpvUrl = () =>
  createSelector(
    selectBank,
    bankState => bankState.tpvUrl,
  );

const makeSelectLiliSocialBank = () =>
  createSelector(
    selectBank,
    bankState => bankState.liliSocialBank,
  );

export {
  selectBank,
  makeSelectBank,
  makeSelectPaymentsResume,
  makeSelectPendingPayments,
  makeSelectSocialProjects,
  makeSelectTpvUrl,
  makeSelectLiliSocialBank,
};
